import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import TableWrapper from "../../../components/TableWrapper";
import Pagination from "../../../components/Tables/Pagination";
import { extractPageData } from "../../../utils/extractPageData";
import Table from "../../../components/Tables";
import { todayReportData } from "../../../assets/data/todayReportData";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { getTableWidth } from "../../../utils/getTableWidth";
function TodayReport() {
  const [tableData, setTableData] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [numberOfRecPerPage, setNumberOfRecordsPerPage] = useState(10);
  const [selectedColumns, setSelectedColumns] = useState([])
  const paginate = (pageNumber) => setCurrentPageNumber(pageNumber);
  const columnsText = ["Compaign ID", "Compaign Name", "Cost", "Clicks", "CTR", "Average CPC", "Leads", "Cost per lead", "Optin Rate", "HQL", "Cost Per HQL"]
  useEffect(() => {
    // Get current list/page data
    if (todayReportData) {
      const data = extractPageData(
        todayReportData,
        currentPageNumber,
        numberOfRecPerPage
      );
      setCurrentPageData(data);
    }
  }, [currentPageNumber, todayReportData, numberOfRecPerPage]);
  useEffect(() => {
    setTableData(todayReportData);
  }, []);
  const windowsDimensions = useWindowDimensions()
  return (
    <div>
      <PageHeader subHeading="Manage your team members and their account permissions here." />
      <TableWrapper
        // maxWidth={getTableWidth(windowsDimensions?.width, "reports")}
        columns={columnsText}
        setSelection={setSelectedColumns}
      >
        <Table
          data={currentPageData}
          columns={Object.keys(todayReportData?.[0]).map((key, index) => ({
            name: key,
            text: columnsText[index]
          }))}
        />
        <Pagination
          totalData={tableData.length}
          dataPerPage={numberOfRecPerPage}
          setNumberOfRecordsPerPage={setNumberOfRecordsPerPage}
          paginate={paginate}
          currentPage={currentPageNumber}
        />
      </TableWrapper>
    </div>
  );
}

export default TodayReport;
